import React, { memo, useCallback } from "react";
import { Card, CardBody, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { Icon } from "ts-react-feather-icons";
import '../../../i18/config';
import {useTranslation} from "react-i18next";

// interface
import { ContentProjectType } from "../../../redux/Content/Project/types";
import ChannelItem from "../PeerChannel/channelItem";
import ChannelItemAdd from "../PeerChannel/channeItemAdd";
import {ContentPeerChannelType} from "../../../redux/Content/PeerChannel/types";
import {connectorHandlerCode} from "../../../constants/ConnectorHandler";

interface ItemProps {
    item: ContentProjectType;
    onEdit?: (event:any) => void;
    onRemove?: (event:any) => void;
}

const ListItem = memo(({ item, onEdit, onRemove }: ItemProps) => {
    const { t } = useTranslation(['common']);

    const handleEdit = useCallback(() => {
        onEdit && onEdit(item);
    }, [onEdit, item]);

    const handleRemove = useCallback(() => {
        onRemove && onRemove(item);
    }, [onRemove, item]);

    return (
        <>
            <Card className="card-height-100 card-animate">
                <CardBody>
                    <div className="d-flex flex-column">
                        <div className="d-flex mb-4">
                            <div className="flex-grow-1 d-flex align-items-center">
                                <p className="text-muted mb-0">
                                    {t('project:project')}
                                </p>
                            </div>
                            <div className="flex-shrink-0">
                                <div className="d-flex align-items-center">
                                    <div>
                                        { item.enabled ?  <span className="badge bg-success">{t('common:active')}</span> :  <span className="badge bg-danger">{t('common:inActive')}</span>}
                                    </div>
                                    <div className="d-flex">
                                        <UncontrolledDropdown direction='start'>
                                            <DropdownToggle tag="a" className="btn btn-sm btn-link text-muted text-decoration-none fs-15">
                                                <Icon name="more-horizontal" />
                                            </DropdownToggle>

                                            <DropdownMenu className="dropdown-menu-end">
                                                {item.actions && item.actions.canEdit && onEdit &&
                                                    <DropdownItem className='edit-item-btn' onClick={handleEdit}>
                                                        <i className="ri-pencil-fill align-bottom text-muted me-2"/> {t('common:edit')}
                                                    </DropdownItem>
                                                }
                                                {item.actions && item.actions.canRemove && onRemove &&
                                                    <DropdownItem className='remove-item-btn' onClick={handleRemove}>
                                                        <i className="ri-delete-bin-fill align-bottom me-2 text-muted"/> {t('common:delete')}
                                                    </DropdownItem>
                                                }
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column h-100">
                        <div className="d-flex mb-2">
                            <div className="flex-shrink-0 me-3">
                                <div className="avatar-sm">
                                    <div className="avatar-title rounded-circle bg-light text-primary fs-16 "
                                         ref={element => {
                                            if (element) element.style.setProperty('background-color', item.color, 'important');
                                    }}>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex flex-grow-1 align-items-center">
                                <h5 className="mb-1 fs-16">{item.name}</h5>
                                { item.description ?
                                <p className="text-muted text-truncate-two-lines mb-3">{item.description}</p> :''}
                            </div>
                        </div>
                    </div>
                </CardBody>
                <div className="card-footer bg-transparent border-top-dashed py-2">
                    <div className="d-flex flex-row">
                        <div className="d-flex flex-column w-50">
                            <div className="mb-1">{t('channel:ownChannels')}</div>
                            <div className="d-flex flex-row flex-wrap avatar-group">
                                {item.channels ? item.channels.map((channel: ContentPeerChannelType, key: number) => (
                                    channel.isManaged && (channel.connector.handler.code !== connectorHandlerCode.CONNECTOR_HANDLER_IDEAS) &&
                                    <ChannelItem item={channel} key={'managedChannel_' + channel.uuid}/>
                                )):''}
                                <ChannelItemAdd/>
                            </div>
                        </div>
                        <div className="d-flex flex-column w-50">
                            <div className="mb-1">{t('channel:competitors')}</div>
                            <div className="d-flex flex-row flex-wrap avatar-group">
                                {item.channels ? item.channels.map((channel: ContentPeerChannelType, key: number) => (
                                    !channel.isManaged &&
                                    <ChannelItem item={channel} key={'competitorsChannel_' + channel.uuid}/>
                                )):''}
                                <ChannelItemAdd/>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </>
    );
});

ListItem.displayName = 'ListItem';

export default ListItem;
